export const globalConfig = {
    apiUrl: '/api',
    //全局变量
  };
  
